import { render, staticRenderFns } from "./SuspendedWarning.vue?vue&type=template&id=c89a7dd6&scoped=true"
import script from "./SuspendedWarning.vue?vue&type=script&lang=js"
export * from "./SuspendedWarning.vue?vue&type=script&lang=js"
import style0 from "./SuspendedWarning.vue?vue&type=style&index=0&id=c89a7dd6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c89a7dd6",
  null
  
)

export default component.exports